import React, { useState } from "react";
import { Link } from "react-router-dom";
import { appAndriod, appApple, logo } from "../../assets";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF } from '@fortawesome/free-brands-svg-icons'; 

export default function Footer2() {
    const [showLinkedIn, setShowLinkedIn] = useState(false);
    const [showLinktree, setShowLinktree] = useState(false);

    const linktreeLinks = [
        { label: 'Explore Our Product Catalogue', sub: 'PDF · Document', href: 'https://linktr.ee/mainlogixca' },
        { label: '30 Minute Call with Us', sub: 'Calendly · Josiah Mainlogix', href: 'https://calendly.com/josiah-mainlogix/mainlogix-technology-canada' },
        { label: 'Registration of Interest', sub: null, href: 'https://linktr.ee/mainlogixca' },
        { label: 'GrandeurSmart at Web Summit 2025 Vancouver', sub: 'Live Event', href: 'https://linktr.ee/mainlogixca' },
        { label: 'Company Profile', sub: 'PDF · Document', href: 'https://linktr.ee/mainlogixca' },
        { label: 'Check out Our Catalog', sub: '1 file · Free', href: 'https://linktr.ee/mainlogixca' },
        { label: 'Partner With Us', sub: null, href: 'https://linktr.ee/mainlogixca' },
        { label: 'Mainlogix (find out more)', sub: null, href: 'http://mainlogix.ca/' },
        { label: 'Grandeur Smart', sub: null, href: 'https://grandeursmart.ca/' },
    ];

    return (
        <div className="py-12 ">
            {/* LinkedIn Popup */}
            {showLinkedIn && (
                <div
                    className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-60"
                    onClick={(e) => { if (e.target === e.currentTarget) setShowLinkedIn(false); }}
                >
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden relative" style={{ height: '80vh' }}>
                        <div className="flex items-center justify-between bg-red-600 px-4 py-3">
                            <div className="flex items-center gap-2">
                                <img src={logo} alt="Mainlogix" className="h-7 object-contain" style={{ filter: 'brightness(0) invert(1)' }} />
                                <span className="text-white font-poppins font-semibold text-sm">Mainlogix on LinkedIn</span>
                            </div>
                            <button
                                onClick={() => setShowLinkedIn(false)}
                                className="text-white hover:text-gray-200 text-2xl font-bold leading-none"
                                aria-label="Close"
                            >&times;</button>
                        </div>
                        <iframe
                            src="https://www.linkedin.com/embed/feed/update/urn:li:company:mainlogix-technology-canada"
                            title="Mainlogix LinkedIn"
                            width="100%"
                            height="100%"
                            frameBorder="0"
                            allowFullScreen
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-white border-t border-gray-200 py-2 px-4 flex justify-center">
                            <a
                                href="https://www.linkedin.com/company/mainlogix-technology-canada/?originalSubdomain=ca"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-red-600 hover:bg-red-700 text-white text-sm font-poppins font-semibold px-5 py-2 rounded-full transition-colors"
                            >
                                View Full LinkedIn Page
                            </a>
                        </div>
                    </div>
                </div>
            )}

            {/* Linktree Popup */}
            {showLinktree && (
                <div
                    className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-60"
                    onClick={(e) => { if (e.target === e.currentTarget) setShowLinktree(false); }}
                >
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm mx-4 overflow-hidden relative flex flex-col" style={{ maxHeight: '85vh' }}>
                        <div className="bg-red-600 px-4 py-4 flex flex-col items-center relative">
                            <button
                                onClick={() => setShowLinktree(false)}
                                className="absolute top-3 right-4 text-white hover:text-gray-200 text-2xl font-bold leading-none"
                                aria-label="Close"
                            >&times;</button>
                            <img src={logo} alt="Mainlogix" className="h-10 object-contain mb-2" style={{ filter: 'brightness(0) invert(1)' }} />
                            <h3 className="text-white font-poppins font-bold text-base">Mainlogix Technology | IoT</h3>
                            <p className="text-red-100 text-xs text-center mt-1">Pioneering IoT with smart home integration for control, privacy, and automation.</p>
                        </div>
                        <div className="overflow-y-auto flex-1 px-4 py-4 flex flex-col gap-3">
                            {linktreeLinks.map((item, i) => (
                                <a
                                    key={i}
                                    href={item.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="block w-full border-2 border-red-600 rounded-full px-4 py-3 text-center hover:bg-red-600 transition-colors group"
                                >
                                    <span className="font-poppins font-semibold text-sm text-red-600 group-hover:text-white block">{item.label}</span>
                                    {item.sub && <span className="text-xs text-gray-400 group-hover:text-red-100">{item.sub}</span>}
                                </a>
                            ))}
                        </div>
                        <div className="px-4 py-3 border-t border-gray-100 text-center">
                            <a href="https://linktr.ee/mainlogixca" target="_blank" rel="noopener noreferrer" className="text-xs text-gray-400 hover:text-red-600">View on Linktree</a>
                        </div>
                    </div>
                </div>
            )}

            <div className="grid pt-3 smd:grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-2 smd:flex smd:flex-col-reverse smd:gap-6">

                <div>
                    <Link to='/'>
                    <img 
                        src={logo} 
                        alt="Mainlogix" 
                       
                        className="smd:h-[50px] smd:w-auto h-[100px] w-[134px]" 
                    />
                    <article className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black">{new Date().getFullYear()} mainlogix.ca</article>
                    </Link>
                </div>
                
                <div className="lg:border-l-[1px] border-gray-300 smd:pl-0 smd:gap-6 pl-2">
                    <h2 className="font-poppins text-red-600 smd:text-[12px] text-[14px] 2xl:text-3xl font-semibold">ABOUT US </h2>
                    <ul className="list-none">
                        <Link to='/contact'>
                            <li className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                                Contact & Consult
                            </li>
                        </Link>
                        <Link to='/technologies-tools'>
                            <li className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                                Technologies & Tools
                            </li>
                        </Link>
                    </ul>
                    <h2 className="font-roboto text-red-600 smd:text-[12px] text-[14px] 2xl:text-3xl font-semibold py-3">SOCIAL LINKS </h2>

                    <div className="flex items-center gap-2 flex-wrap">
                        {/* Facebook */}
                        <a href="https://m.facebook.com/" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon 
                                icon={faFacebookF} 
                                size="1x" 
                                color="white" 
                                className="bg-red-600 rounded-full px-3.5 py-3" 
                            />
                        </a>

                        {/* LinkedIn — opens popup */}
                        <button
                            onClick={() => setShowLinkedIn(true)}
                            className="rounded-full py-3 px-3 bg-red-600 hover:bg-red-700 transition-colors cursor-pointer"
                            aria-label="LinkedIn"
                        >
                            <svg 
                                xmlns="http://www.w3.org/2000/svg" 
                                width="15" 
                                height="15" 
                                viewBox="0 0 24 24"
                                fill="#FFFFFF"
                            >
                                <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"/>
                            </svg>
                        </button>

                        {/* Linktree — opens popup */}
                        <button
                            onClick={() => setShowLinktree(true)}
                            className="rounded-full py-2 px-3 bg-red-600 hover:bg-red-700 transition-colors cursor-pointer flex items-center gap-1"
                            aria-label="Linktree"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="#FFFFFF">
                                <path d="M12 2a1 1 0 0 1 .707.293l3 3a1 1 0 0 1-1.414 1.414L13 5.414V11h5.586l-1.293-1.293a1 1 0 0 1 1.414-1.414l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L18.586 13H13v5.586l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1 1.414-1.414L11 18.586V13H5.414l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 1.414L5.414 11H11V5.414L9.707 6.707A1 1 0 0 1 8.293 5.293l3-3A1 1 0 0 1 12 2z"/>
                            </svg>
                            <span className="text-white text-[11px] font-poppins font-semibold">Linktree</span>
                        </button>
                    </div>
                    <div >
                    <div className="flex items-center justify-start gap-1 flex-row mr-10 pt-3" >
                      <div>
                      <img src={appApple} alt="" className="" />
                      </div>
                      <div>
                      <Link to='https://play.google.com/store/apps/details?id=com.grandeursmart.home.android'>
                        <img src={appAndriod} alt="" className=""/>
                      </Link>
                      </div>
                    </div>
                  </div>
                </div>

                <div >
                    <h2 className="font-poppins text-red-600 smd:text-[12px] text-[14px] 2xl:text-3xl font-semibold">QUICK LINKS </h2>
                    <ul className="list-none">
                        <Link to='/iot-development-services' >
                        <li className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                            IoT Development Services
                        </li>
                        </Link>
                        <Link to='/general-features' >
                        <li className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                            General Features
                        </li>
                        </Link>
                        <Link to='/operating-system-development' >
                        <li className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                            Operating System Development
                        </li>
                        </Link>
                        <Link to='/existing-solutions' >
                        <li className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                            Existing Solutions
                        </li>
                        </Link>
                        <Link to='/iot-product-development-step' >
                        <li className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                            IoT Product Development Steps
                        </li>
                        </Link>
                        <Link to='/smart' >
                            <li className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                                Smart by Mainlogix
                            </li>
                        </Link>
                    </ul>
                </div>
                <div>
                    <h2 className="font-poppins text-red-600 smd:text-[12px] text-[14px] 2xl:text-3xl font-semibold">LINKEDIN FEEDS</h2>
                    <div>

                        <iframe src='https://widgets.sociablekit.com/linkedin-page-posts/iframe/25463894' frameborder='0' width='90%' height='100%' title="Embedded post"></iframe>

                    </div>
                    
                </div>
            </div>
        </div>
    );
}
